import React, { useState } from "react";
import Sider from "antd/es/layout/Sider";
import styled, { css } from "styled-components";
import { DesignTokens } from "../../styles/design-tokens";
import { ElevationHelper } from "../../helper/ElevationHelper";

const { spacings, colors, fonts, elevations, dimensions } = DesignTokens;
const { createBoxShadowCSSString } = ElevationHelper;

const StyledSider = styled(Sider)`
  &.ant-layout-sider {
    overflow-x: hidden;
    overflow-y: auto;
    height: 100vh;
    position: sticky;
    top: 0;
    left: 0;
    box-shadow: ${createBoxShadowCSSString({ level: 1 })};
    z-index: ${elevations.level1.zIndex};
    border-right: 1px solid ${colors.gray.light};
  }

  .ant-layout-sider-trigger {
    border-right: 1px solid ${colors.gray.light};
  }
`;

const SiderHeader = styled.div`
  margin-top: ${spacings.large / 2}px;
`;

const SiderContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 48px; /* make sure that the sider trigger is not overlayed on top of the menu */
`;

const StyledLogo = styled.img<{ isSiderCollapsed: boolean }>`
  height: 25px;
  margin: 0 ${spacings.xlarge}px;

  ${({ isSiderCollapsed }) =>
    isSiderCollapsed &&
    css`
      margin-left: 24px;
    `}
`;

const StyledApplicationName = styled.div<{ isSiderCollapsed: boolean }>`
  font-family: ${fonts.sansSerifMd};
  margin: 0 ${spacings.xlarge}px ${spacings.xlarge}px ${spacings.xlarge}px;

  ${({ isSiderCollapsed }) =>
    isSiderCollapsed &&
    css`
      font-size: 10px;
      text-align: center;
      margin: 5px 0 38px 0;
    `}
`;

type MainNavigationProps = {
  appName: string;
  logo: string;
  logoCollapsed?: string;
  mainMenu: React.ReactNode;
};

const MainNavigation: React.FC<MainNavigationProps> = ({
  appName,
  logo,
  logoCollapsed,
  mainMenu,
}) => {
  const [isSiderCollapsed, setSiderCollapsed] = useState(false);

  let logoToShow = logo;
  if (logoCollapsed && isSiderCollapsed) {
    logoToShow = logoCollapsed;
  }

  return (
    <StyledSider
      collapsible
      collapsed={isSiderCollapsed}
      onCollapse={setSiderCollapsed}
      width={dimensions.sider}
    >
      <SiderHeader>
        <StyledLogo src={logoToShow} isSiderCollapsed={isSiderCollapsed} />
        <StyledApplicationName isSiderCollapsed={isSiderCollapsed}>
          {appName}
        </StyledApplicationName>
      </SiderHeader>
      <SiderContent>{mainMenu}</SiderContent>
    </StyledSider>
  );
};

export { MainNavigation };
